var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('path',{class:_vm.classObject,attrs:{"d":_vm.hullLine}})
}
var staticRenderFns = []

export { render, staticRenderFns }